export * from './lib/web-components-map.component';
